import { html } from "lit";

export const dummyEvent = {
    year: "2021",
    month: "Feb.",
    days: "12-14",
    location: "Halle 8, Stand 34B",
    title: "Laser World of Photonics China 2021",
    category: "power tools",
    link: "#",
    linkText: "messe, austellung",
};

export const dummyEvents = [
    {
        ...dummyEvent,
    },
    {
        ...dummyEvent,
        month: "Mar.",
        title: "Lorem ipsum dolor sit amet",
    },
    {
        ...dummyEvent,
        days: "25-26",
    },
    {
        ...dummyEvent,
        month: "Oct.",
        title: "Sed do eiusmod",
    },
    {
        ...dummyEvent,
        month: "Jul.",
        days: "19-20",
        title: "Incididunt ut labore et",
    },
    {
        ...dummyEvent,
        days: "19-23",
    },
    {
        ...dummyEvent,
        title: "Ut enim ad minim veniam",
    },
    {
        ...dummyEvent,
        month: "Jun.",
        title: "Quis nostrud exercitation",
    },
    {
        ...dummyEvent,
        month: "Dec.",
    },
    {
        ...dummyEvent,
        days: "02-04",
        title: "Excepteur sint occaecat",
    },
];

export const TeaserEventTemplate = (args = dummyEvent) => html`
    <ux-iws-link-wrapper class="ux-iws-teaser-event">
        <div class="ux-iws-teaser-event__date-wrapper">
            <span class="ux-iws-teaser-event__year"> ${args.year} </span>
            <span class="ux-iws-teaser-event__date">
                <span>${args.month}</span>
                <span>${args.days}</span>
            </span>
        </div>
        <div class="ux-iws-teaser-event__content-wrapper">
            <span class="ux-iws-teaser-event__location">
                ${args.location}
            </span>
            <p
                class="ux-text-title-teaser ux-u-margin-top-5 ux-u-margin-bottom-10"
            >
                ${args.title}
            </p>
            <ux-tag disabled> ${args.category} </ux-tag>
            <a class="ux-button" href="${args.link}"> ${args.linkText} </a>
        </div>
    </ux-iws-link-wrapper>
`;

export const TeaserEventListTemplate = () => html`
    <div class="ux-iws-teaser-event-grid">
        ${dummyEvents.map((tile) => TeaserEventTemplate(tile))}
    </div>
`;
